import * as R from "ramda";

import { EndPoints } from "../../api-config";
import { pageLimit } from "../../paginations/paginationLimit";
let SERVER_ADDR_V1 = EndPoints.backendHost;

export const aidavieFilesUrl = (page, search, sortBy, sortDesc, operatorId, fromCreationDate, toCreationDate) =>
	`${SERVER_ADDR_V1}/aidavie/files?pagesize=${pageLimit}&pagenumber=${parseInt(page) - 1}${search === "" ? "" : "&textSearch=" + search}${sortBy === "" ? "" : "&sortBy=" + sortBy}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}
	${operatorId !== "" ? "&operatorId=" + operatorId : ""}${fromCreationDate !== "" && !R.isNil(fromCreationDate) ? "&fromCreationDate =" + fromCreationDate : ""}${toCreationDate !== "" && !R.isNil(toCreationDate) ? "&toCreationDate=" + toCreationDate : ""}`;

export const aidavieFileByIdUrl = (id) => `${SERVER_ADDR_V1}/aidavie/files/${id}`;
